package components

import core.enums.EImages
import csstype.AlignSelf
import csstype.Auto
import csstype.Display
import csstype.Margin
import csstype.NamedColor
import csstype.Position
import csstype.integer
import csstype.minus
import csstype.pct
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 18.10.22
 * Author : marcusspors
 */

external interface AlpinaLogoProps : Props {
}

val AlpinaLogo = FC<AlpinaLogoProps> { props ->

    ReactHTML.div {
        id = "alpina-logo"
        css {
            display = Display.flex
            backgroundColor = NamedColor.white
            position = Position.absolute
            width = 134.px
            height = 134.px
            left = 50.pct - (134 / 2).px
            bottom = (-42).px
            borderRadius = 50.pct
            zIndex = integer(12)
        }
        ReactHTML.img {
            css {
                height = 72.px
                paddingBottom = 16.px
                alignSelf = AlignSelf.flexEnd
                margin = Margin(0.px, Auto.auto)
            }
            src = EImages.ALPINA_LOGO.mRelativePath
        }
    }
}